import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { P } from '@osmosis/tailwind-ui/components/Text';
import React from 'react';

import { VideoChapter } from '@osmosis/shared/types/learndb/learnData';

import { PROD_MEDIA_SERVER } from '@osmosis/constants';

type ChapterBrowserProps = {
  chapters: VideoChapter[];
  currentPosition: number;
  handleChangePosition: (value: number) => void;
};

/**
 * .
 */
export default function ChapterBrowser({
  chapters,
  currentPosition,
  handleChangePosition,
}: ChapterBrowserProps): JSX.Element {
  return (
    <Box className={`h-[300px] w-[300px] pb-2 overflow-y-scroll rounded-[5px]`}>
      {chapters.map(({ title, thumb, chapterID, start }, index) => {
        const nextStart = chapters[index + 1]?.start;
        const position = +start;
        const isCurrent =
          currentPosition >= position && currentPosition < +nextStart;
        return (
          <Flex
            key={chapterID}
            onClick={(): void => handleChangePosition(position)}
            className={`hover:bg-gray-300 focus:bg-gray-300 items-center p-2 cursor-pointer`}
            data-testid="chapter-browser-item"
          >
            <img
              src={`${PROD_MEDIA_SERVER}${thumb}`}
              alt={title}
              width={70}
              height={40}
            />

            <P
              className={`!ml-2 ${
                isCurrent ? 'text-primary-700 font-bold' : 'text-gray-800'
              }`}
            >
              {title}
            </P>
          </Flex>
        );
      })}
    </Box>
  );
}
